import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const LCCAnalyzer = () => {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // ✅ For popup

  const handleChange = (e) => {
    setFile(e.target.files[0]);
    setError("");
    setResult(null);
  };

  const handleSubmit = async () => {
    if (!file) {
      setError("Please select an image file first.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const formData = new FormData();
      formData.append("leaf", file);
      console.log("📤 Uploading file:", file);

      const { data } = await axios.post("http://localhost:5001/api/lcc/analyze", formData);
      console.log("✅ Got response:", data);

      setResult(data);
      setShowModal(true); // ✅ Show popup
    } catch (err) {
      console.error("❌ Error uploading:", err);
      setError(err.response?.data?.error || "Something went wrong while analyzing.");
    } finally {
      setLoading(false);
    }
  };

 
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <div style={{ width: "250px", backgroundColor: "#2e7d32", color: "white", padding: "30px 20px" }}>
        <h2 style={{ textAlign: "center" }}>Smart Farming</h2>
        <nav style={{ display: "flex", flexDirection: "column", gap: "35px", paddingLeft: "30px" }}>
          {["HOME", "CROP", "FERTILIZER", "WEATHER", "LEAF COLOR CHART"].map((item) => {
            const path = item === "LEAF COLOR CHART" ? "/lcc" : `/${item.toLowerCase()}`;
            return (
              <Link key={item} to={path} style={{ color: "white", textDecoration: "none" }}>
                {item}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          backgroundColor: "#f8f9fa",
          height: "100vh",
          overflowY: "auto",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <h2
          style={{
            backgroundColor: "#2e7d32",
            color: "white",
            margin: 0,
            padding: "15px",
            width: "100%",
            textAlign: "center",
          }}
        >
          Leaf Colour Chart Analyzer 🌿
        </h2>

        {/* Form */}
        <div
          style={{
            backgroundColor: "white",
            marginTop: "35px",
            padding: "20px",
            borderRadius: "10px",
            width: "80%",
            maxWidth: "600px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleChange}
            style={{ padding: "10px", width: "100%", marginBottom: "20px", borderRadius: "5px" }}
          />
          {file && (
            <div style={{ marginTop: "15px" }}>
              <p>
                <strong>Selected file:</strong> {file.name}
              </p>
              <img
                src={URL.createObjectURL(file)}
                alt="Leaf preview"
                style={{ maxWidth: "100%", height: "auto", borderRadius: "5px" }}
              />
            </div>
          )}
          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              marginTop: "20px",
              padding: "10px",
              backgroundColor: "#2e7d32",
              color: "white",
              borderRadius: "5px",
              border: "none",
              width: "100%",
            }}
          >
            {loading ? "Analyzing..." : "Analyze"}
          </button>
        </div>

        {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}

        {/* ✅ Modal Popup */}
        {showModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              style={{
                background: "white",
                padding: "30px 20px",
                borderRadius: "10px",
                maxWidth: "800px",
                width: "90%",
                maxHeight: "80vh", // ✅ Limit height
                overflowY: "auto", // ✅ Enable scroll inside modal
                textAlign: "center",
                position: "relative",
              }}
            >
              <button
                onClick={() => setShowModal(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  fontSize: "18px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                ✖
              </button>

              <h3>Leaf Analysis Result:</h3>
              {result ? (
                <div
                  style={{
                    marginTop: "20px",
                    border: "1px solid #ccc",
                    padding: "15px",
                    borderRadius: "10px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <p><strong>Average Leaf Color:</strong> RGB({result.avgColor.join(", ")})</p>
                  <p><strong>Matched Shade:</strong> {result.matchedShade}</p>
                  <p><strong>Nitrogen Status:</strong> {result.nitrogenStatus}</p>
                  <p><strong>Recommendation:</strong> {result.recommendation}</p>
                </div>
              ) : (
                <p>No result found yet.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LCCAnalyzer;
